export function round(value, decimals = 2) {
  if (value == null || Number.isNaN(value)) return null;
  return Math.round(value * 10 ** decimals) / 10 ** decimals;
}
